import React from 'react';
import { ShieldCheck, Circle, Clock } from 'lucide-react';

/**
 * Level authorisation is a two-party step: the organisation requests it, Diverse Integration verifies and approves
 * from the provider console. `status` is 'none' | 'requested' | 'authorised' | 'returned'.
 */
export default function LevelAuthorisation({ level, levelLabel, allCriteriaMet, status = 'none', notes, onRequest, questionCount, requesting }) {
  if (status === 'authorised') {
    return (
      <div className="bg-teal-50 border border-teal-200 rounded-xl p-4">
        <div className="flex items-center gap-2.5">
          <ShieldCheck className="w-5 h-5 text-teal-700 shrink-0" aria-hidden="true" />
          <div>
            <p className="text-sm font-semibold text-teal-800">Level {level} — {levelLabel} Authorised</p>
            <p className="text-xs text-teal-700 mt-0.5">Verified and authorised by Diverse Integration.</p>
          </div>
        </div>
      </div>
    );
  }
  if (status === 'requested') {
    return (
      <div className="bg-sky-50 border border-sky-200 rounded-xl p-4">
        <div className="flex items-center gap-2.5">
          <Clock className="w-5 h-5 text-sky-600 shrink-0" aria-hidden="true" />
          <div>
            <p className="text-sm font-semibold text-sky-800">Level {level} authorisation requested</p>
            <p className="text-xs text-sky-700 mt-0.5">Diverse Integration will review your answers and evidence and confirm, or come back with what is missing.</p>
          </div>
        </div>
      </div>
    );
  }
  if (!allCriteriaMet) {
    return (
      <div className="bg-muted border border-border rounded-xl p-4">
        <div className="flex items-center gap-2.5">
            <Circle className="w-5 h-5 text-muted-foreground shrink-0" aria-hidden="true" />
          <div>
            <p className="text-sm font-semibold text-foreground">Level {level} DI authorisation is not yet available</p>
            <p className="text-xs text-muted-foreground mt-0.5">You can still submit your self-assessment. You can request DI review when all {questionCount} questions have a confirmed Completed answer.</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
      <div className="flex items-center gap-2.5 mb-3">
        <ShieldCheck className="w-5 h-5 text-amber-600 shrink-0" aria-hidden="true" />
        <div>
          <p className="text-sm font-semibold text-amber-800">{status === 'returned' ? `Level ${level} returned for more evidence` : `Ready for Level ${level} Authorisation`}</p>
          <p className="text-xs text-amber-700 mt-0.5">{status === 'returned' && notes ? notes : 'Every question has a confirmed Completed answer. Ask Diverse Integration to verify your answers and evidence before authorising this level.'}</p>
        </div>
      </div>
      <button
        onClick={onRequest}
        disabled={requesting}
        className="assessment-primary min-h-11 flex items-center gap-2 px-4 py-2 rounded-lg bg-teal-700 text-white text-sm font-semibold hover:bg-amber-700 disabled:opacity-50 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-amber-400"
      >
        <ShieldCheck className="w-4 h-4" aria-hidden="true" />
        {requesting ? 'Requesting…' : `Request Level ${level} authorisation`}
      </button>
    </div>
  );
}
